import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8tg8mxotwp: FaireBrandEntity = {
  token: "b_8tg8mxotwp",
  type: "brand",
  name: "PINCH",
  avatarUrl:
    "https://cdn.faire.com/fastly/67c2c27886423511713ee5bcb7d827b796cdd5a2a29d525213084d0bbafd74a4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dbda84e110913696149a94a40bb786008f4a7eb1d8dc4153ce91dbc88897a97e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/67c2c27886423511713ee5bcb7d827b796cdd5a2a29d525213084d0bbafd74a4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dbda84e110913696149a94a40bb786008f4a7eb1d8dc4153ce91dbc88897a97e.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.7,
  reviewCount: 169,
  isInsider: true,
  description:
    "PINCH is a women`s apparel wholesale brand dedicated to providing pieces that can be a staple in every wardrobe.\n\nPINCH is always evolving to stay trendy and competitive in quality. We are committed to producing effortlessly versatile pieces by searching for the highest quality and staying ahead of the season to provide the latest trends for the everyday PINCH girl. #getPINCHed",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:43.093Z",
    importedBy: "entity-db-cli",
  },
};
